<form #form="ngForm">
    <div class="container-fluid">
        <div class="row justify-content-md-center align-self-center">
            <div class="form-group col-12">
                <div class="mt-3">
                    <div class="col">
                        <span class="d-flex ml-auto">
                            {{'new-envelope.mergeFiles' | translate }}
                            <fa-icon ngbTooltip="{{'new-envelope.tooltip' | translate}}"
                            placement="right" class="ml-1 fa-gray mr-1" size="sm" [icon]="['fas','question-circle']">
                        </fa-icon>
                            <cdx-toggle-switch class="ml-1" [toggledOn]="fileValidateService.mergePDF"
                                (toggle)="onToggleMergeFiles($event)" [disabled]="disabledMergeFiles()">
                            </cdx-toggle-switch>
                        </span>
                    </div>
                </div>
                <ngfFormData [files]="files" postName="file" [(FormData)]="formData"></ngfFormData>
                <input type="file" #fileInput multiple hidden (change)="onFilesSelected($event.target.files)">
                <div class="upload">
                    <div ngfDrop multiple="1" [(files)]="files"
                        (filesChange)="onFilesDragDrop($event)" (click)="fileInput.click()" class="dragDrop flex-column">
                        <div>
                            <p class="primary text-center">
                                <fa-icon class="mr-2" [icon]="['fal','paperclip']"></fa-icon>
                                {{ 'new-envelope.Click here or drag files to add' | translate }}
                            </p>
                        </div>
                        <div>
                            <p class="text-center">
                                <small class="gray-40">{{ 'new-envelope.Maximum limit of' | translate }} {{
                                    maxSizeAttachFiles }} mb</small>
                            </p>
                        </div>
                    </div>
                    <div class="container-file" style="width: 100% !important;" *ngIf="files.length">
                        <div class="file" *ngFor="let item of files; let i = index">
                            <span class="text-truncate">{{ item.name }}</span>
                            <fa-icon [icon]="['fas','times-circle']" (click)="deleteFile(i)"></fa-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
